import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { RoleGuard } from '@core/guards/role.guard';
import { MainLayoutComponent } from '@layouts/main-layout/main-layout.component';
import { Error404Component } from './pages/error/error-404/error-404.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'campaigns/list',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.route').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    component: MainLayoutComponent,   // shell
    canActivate: [AuthGuard],
    children: [
      // {
      //   path: 'dashboard',
      //   loadComponent: () =>
      //     import('./pages/dashboards/dashboard.component')
      //       .then(m => m.DashboardComponent),
      // },
      // {
      //   path: 'reports',
      //   loadChildren: () =>
      //     import('./pages/reports/reports.route').then(
      //       (m) => m.REPORTS_ROUTES
      //     ),
      // },
      {
        path: 'users',
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./pages/users/users.route').then(
            (m) => m.USERS_ROUTES
          ),
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./pages/campaigns/campaigns.route').then(
            (m) => m.CAMPAIGNS_ROUTES
          ),
      },
      {
        path: 'audit-logs',
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./pages/audit-logs/audit-logs.route').then(
            (m) => m.AUDIT_LOGS_ROUTES
          ),
      },
    ],
  },
  {
    path: 'permission-denied',
    loadComponent: () =>
      import('./pages/error/error-403/error-403.component')
        .then(m => m.Error403Component),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/error/error-404/error-404.component')
        .then(m => m.Error404Component),
  },
];
